// @TODO Remove this cheat once we have multiple image sets per page
const getVolumeId = (prefix, planSer, fraction, groupIndex) =>
  `cornerStreamingImageVolume: ${prefix}|${planSer}|${'X' ?? fraction}|${groupIndex}`;

export default getVolumeId;